import * as log from "loglevel";
import * as marked from "marked";
import * as React from "react";

import { inject, observer } from "mobx-react";
import { Button, Confirm, Form, Modal, TextArea } from "semantic-ui-react";

import { ReleaseNote as ReleaseNoteComponent } from "../../components/release-note";
import { ReleaseNote } from "../../stores/models/releasenote";
import { ReleaseNoteStore } from "../../stores/releasenote-store";
import { LoadingSpinner } from "../common/loading-spinner";

interface IAdminViewProps{
	releaseNoteStore?: ReleaseNoteStore;
}

interface IAdminViewState{
	releaseNote: ReleaseNote;
	releaseNoteConfirm: boolean;
}


@inject("releaseNoteStore") @observer
export class AddReleaseNote extends React.Component<IAdminViewProps, IAdminViewState>{
	constructor(props, state){
		super(props, state);
		this.state = {
			"releaseNote": new ReleaseNote(),
			"releaseNoteConfirm": false
		};
		this.openReleaseConfirm = this.openReleaseConfirm.bind(this);
		this.closeReleaseConfirm = this.closeReleaseConfirm.bind(this);
		this.confirmReleaseNote = this.confirmReleaseNote.bind(this);
	}

	async confirmReleaseNote(){
		console.log("release", this.state.releaseNote);
		await this.props.releaseNoteStore.addNote(this.state.releaseNote);
		await this.props.releaseNoteStore.loadNotes();
		this.setState({
			"releaseNoteConfirm": false,
			"releaseNote": new ReleaseNote()
		});
	}

	openReleaseConfirm(){
		this.setState({
			"releaseNoteConfirm": true
		});
	}

	closeReleaseConfirm(){
		this.setState({
			"releaseNoteConfirm": false
		});
	}

	render(){
		return (
			<div>
				<Confirm open={this.state.releaseNoteConfirm} onCancel={this.closeReleaseConfirm} onConfirm={this.confirmReleaseNote} content={<div style={{"padding": "20px"}}>Are you sure you want to push this release note? For reference, here is the note that will go out:<br/><ReleaseNoteComponent key={-1} releaseNote={this.state.releaseNote} /></div>} header="Release confirmation" confirmButton="Yes" cancelButton="No"/>
				{this.props.releaseNoteStore.loading &&
					<LoadingSpinner text="Loading Release Notes" />
				}
				<Form onSubmit={this.openReleaseConfirm}>
					<Form.Field inline>
						<label>
							Release Note Text (This field accepts Markdown, for syntax click <a href="https://github.com/adam-p/markdown-here/wiki/Markdown-Cheatsheet" target="_blank">here</a>).
						</label>
						<TextArea value={this.state.releaseNote.text} onChange={(e, data) => { this.state.releaseNote.updateProperty("text", data.value); }}/>
					</Form.Field>
					<Form.Input inline placeholder="01/01/2000" label="Release Date" value={this.state.releaseNote.releaseDate} onChange={(e, data) => { this.state.releaseNote.updateProperty("releaseDate", data.value); }}/>
					<Modal trigger={<Button className="jibunu-green" content="Preview" size="small" type="button"/>}>
						<ReleaseNoteComponent key={-1} releaseNote={this.state.releaseNote} />
					</Modal>
					<br/>
					<br/>
					<Button className="jibunu-red" type="submit" content="Add release note" disabled={this.state.releaseNote.text === "" || this.state.releaseNote.releaseDate === ""}/>
				</Form>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/views/admin/add-release-note.tsx